import {useTranslation} from '@app/hooks/use-translation';
import type {FunctionComponent} from 'react';
import {Image} from '@app/components/Image';
import type {LocalImageConfig} from '@app/hooks/use-local-image';
import {useLocalImage} from '@app/hooks/use-local-image';
import {LandingHeading, LandingParagraph} from '@tempo/landing';
import {LandingIllustrationSection} from '@app/components/layout/LandingIllustrationSection';

const IMAGE_CONFIG: LocalImageConfig = {
	default: '90a485390b02372b62fd728bec45c293.png',
	pt: '7e105b93ae59474248b3c2446cbe7f4e.png',
	'pt-br': '7e105b93ae59474248b3c2446cbe7f4e.png',
	de: 'c5dde21cc04c05e21711dd57e0f86770.png',
	fr: '4d7b19fc8a4482aad95c649702bf4994.png',
};

export const LyricsOffline: FunctionComponent = () => {
	const {t} = useTranslation();

	const src = useLocalImage(IMAGE_CONFIG);
	return (
		<LandingIllustrationSection
			imagePosition="left"
			description={
				<>
					<LandingHeading as="h2">
						{t('lyricslandingpage_title_singwhereveryouare_standalone-web', {
							ns: 'lyrics',
						})}{' '}
					</LandingHeading>
					<LandingParagraph>
						{t('lyricslandingpage_text_singwhereveryouare_standalone-web', {
							ns: 'lyrics',
						})}
					</LandingParagraph>
				</>
			}
			image={
				<Image
					sizes={{base: '100vw', md: '50vw'}}
					src={src}
					aspectRatio="2048/1661"
					alt={t('metatag_text_offlinelyrics_standalone-web', {ns: 'common'})}
				/>
			}
		/>
	);
};
